import { Honeybadger } from '@honeybadger-io/react';

export const getLoggingContext = (userEmail?: string, userId?: string) => {
    return {
        userEmail: userEmail || 'unknown',
        userId: userId || 'unknown',
    };
};

type LogEventLevel = 'INFO' | 'DEBUG' | 'TRACE' | 'WARN' | 'ERROR';

interface LogEventOptions {
    level?: LogEventLevel;
    customAttributes?: object;
}

export enum EVENT_LOG_NAMES {
    // Navigation
    LoginVerifyClick = 'Login - Verify Click',
    OpenApplicantClick = 'Open Applicant - Click',
    ViewApplicantQueueClick = 'View Applicant Queue - Click',

    // Tab Navigation
    TabApplicationView = 'Tab - Application View',
    TabDDDView = 'Tab - DDD View',
    TabActivityView = 'Tab - Activity View',
    TabDocumentsView = 'Tab - Documents View',
    TabTagsSignalsView = 'Tab - Tags/Signals View',

    // Factoring Actions
    FactoringDecision = 'Factoring - Decision',
    FactoringRequestInfo = 'Factoring - Request Info',
    FactoringEdit = 'Factoring - Edit',
    FactoringAssign = 'Factoring - Assign',

    // LoadPay Actions
    LoadPayDecision = 'LoadPay - Decision',
    LoadPayRequestInfo = 'LoadPay - Request Info',
    LoadPayEdit = 'LoadPay - Edit',
    LoadPayAssign = 'LoadPay - Assign',

    // TcsFuel Actions
    TcsFuelDecision = 'TcsFuel - Decision',
    TcsFuelRequestInfo = 'TcsFuel - Request Info',
    TcsFuelEdit = 'TcsFuel - Edit',
    TcsFuelAssign = 'TcsFuel - Assign',

    // Other Actions
    RefreshClick = 'Refresh - Click',
    AlloyShortcutClick = 'Alloy Shortcut - Click',
    SalesforceShortcutClick = 'Salesforce Shortcut - Click',
    AddInternalNoteClick = 'Add Internal Note - Click',
    AddNewDocumentClick = 'Add New Document - Click',

    // Queue Filters
    QueueFiltersApply = 'Queue Filters - Apply',
    QueueFiltersReset = 'Queue Filters - Reset',
    QueueFiltersChipRemove = 'Queue Filters - Chip Remove',

    // Errors
    ErrorBoundaryCaught = 'Error - Boundary Caught',
    QueueConditionCountsRefreshError = 'Queue Condition Counts Refresh - Error',
    FeaturePermissionsLoadError = 'Feature Permissions Load - Error',

    // Edge Case
    Exception = 'Exception',
}

export const honeybadgerLogEvent = (eventName: string, options: LogEventOptions) => {
    const logLevel = options.level ?? 'INFO';

    // for FullStory visibility
    console.log(eventName, options.customAttributes);

    // Only log Errors to Honeybadger for now. Don't want INFO or WARN level.
    if (logLevel === 'ERROR') {
        Honeybadger.notify({
            name: eventName,
            tags: [logLevel],
            context: {
                ...options.customAttributes,
            },
        });
    }
};
